import React, { useMemo } from "react";
import { Card, List, Avatar, Tag, Typography } from "antd";
import {
ScheduleOutlined,
FileTextOutlined,
UserOutlined
} from "@ant-design/icons";

import dayjs from "dayjs";

const { Text } = Typography;

export default function NotificationPanel({
attendanceNotifications = [],
expiries = [],
activities = [],
notificationsCount = 0
}) {

const previewItems = useMemo(() => {

return [

...attendanceNotifications.map((a)=>({
type:"attendance",
...a
})),

...expiries.map((e)=>({
type:"expiry",
...e
})),

...activities.map((a)=>({
type:"activity",
...a
}))

].slice(0,6);

},[attendanceNotifications,expiries,activities]);

return(

<Card
title={
<div style={{display:"flex",gap:8}}>
🔔 Notifications
<Tag color="red">{notificationsCount}</Tag>
</div>
}
>

{previewItems.length ? (
  <div style={{ maxHeight: "40vh", overflowY: "auto", scrollbarWidth: "thin", }}>
    <List
      dataSource={previewItems}
      itemLayout="horizontal"
      split
      renderItem={(item) => {
        const icon =
          item.type === "expiry"
            ? <FileTextOutlined />
            : item.type === "activity"
            ? <UserOutlined />
            : <ScheduleOutlined />;

        return (
          <List.Item>
            <List.Item.Meta
              avatar={<Avatar icon={icon} />}
              title={
                <Text strong>
                  {item.employee_name || item.activity_name}
                </Text>
              }
              description={
                <>
                  {item.status && (
                    <>
                      <div>Date: {dayjs(item.date).format("DD-MM-YYYY")}</div>
                      <div>Type: {item.type}</div>
                      <div>
                        Status:{" "}
                        <Tag
                          color={
                            item.status?.toLowerCase()?.includes("awaiting")
                              ? "red"
                              : item.status?.toLowerCase()?.includes("inprogress")
                              ? "orange"
                              : "green"
                          }
                        >
                          {item.status}
                        </Tag>
                      </div>
                    </>
                  )}

                  {item.days !== undefined && (
                    <Text type="secondary">
                      {item.label}: {item.days} days
                    </Text>
                  )}

                  {item.created_date && (
                    <Text type="secondary">
                      {new Date(item.created_date).toLocaleString()}
                    </Text>
                  )}
                </>
              }
            />
          </List.Item>
        );
      }}
    />
  </div>
) : (

<div style={{textAlign:"center",padding:20}}>

<Text type="secondary">No notifications</Text>

</div>

)}

</Card>

);

}